module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_icon_12.d9424f57.png";